export default

    class Address {
    constructor(street="", number="", zip="", neighborhood="", state="", city="", latitude="", longitude="",address_formatted="") {
        this.street = street
        this.number = number
        this.zip = zip
        this.neighborhood = neighborhood
        this.state = state
        this.city = city
        this.latitude = latitude
        this.longitude = longitude
        this.address_formatted = address_formatted
        
    }
}